export default "__VITE_ASSET__CiN4wniX__"